import { IButton } from "types/gaiaComponents/button";
import React from "react";
import { Tooltip } from "components/tooltip/Tooltip";


export const ButtonType = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    GHOST: "ghost",
    TRANSPARENT: "transparent",
}
export const Button = React.forwardRef((props: IButton, ref) => {
    // When a `tooltip` is provided, the button becomes the react-tooltip trigger via
    // `data-for`/`data-tip` and we render the matching <Tooltip> as a sibling, so callers
    // don't need to wrap the button themselves. `title` still works for a plain native tooltip.
    const hasTooltip = !!(props.tooltip?.id && props.tooltip?.content);
    const button = (
        <button className={`ga-button ga-button--${props.type}${props.iconOnly ? " ga-button--icon-only" : ""}${props.extraClassName? " "+props.extraClassName: ""}`}
                id={props.id}
                type={"button"}
                //@ts-ignore
                ref={ref}
                disabled={props.disabled}
                onClick={props.onClick}
                onBlur={props.onBlur}
                title={props.title}
                tabIndex={props.tabIndex}
                data-cy={props.dataCy}
                data-testid={props.dataTestId}
                data-target={props.dataTarget}
                data-toggle={props.dataToggle}
                data-for={hasTooltip ? props.tooltip!.id : undefined}
                data-tip={hasTooltip ? "" : undefined}
                aria-label={props.ariaLabel}>
            {props.icon}
            {props.text}
            {props.rightIcon}
        </button>
    );

    if (!hasTooltip) {
        return button;
    }

    return (
        <>
            {button}
            <Tooltip
                id={props.tooltip!.id}
                place={props.tooltip!.place}
                content={props.tooltip!.content}
            />
        </>
    );
});